import { Box, Link as JLink, ListItem, Stack } from 'juhuui';
import React, { forwardRef, useEffect } from 'react';
import shallow from 'zustand/shallow';

import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { Bright, ContainerOuter, grid12, GridHalfFull, HeadingLg, TextMd } from '../styles';
import { Disease, GraphQLData } from '../types';
import { getLocalizationObj } from '../utilities/getLocalizationObj';
import { useStore } from '../zustand';
import ListYBorder from './listYBorder';

export const ServicesDiseases = forwardRef(
  ({ diseaseTitle, diseaseInformation, diseases }, ref) => {
    const [diseasesInView] = useIntersectionObserver(ref, {});

    const [setSubNavigationServices, setServicesInView] = useStore(
      (state) => [state.setSubNavigationServices, state.setServicesInView],
      shallow
    );

    useEffect(() => {
      setSubNavigationServices(2);

      if (diseasesInView) {
        setServicesInView({ 2: true });
      } else {
        setServicesInView({ 2: false });
      }
    }, [diseasesInView]);

    return (
      <Bright>
        <ContainerOuter
          ref={ref}
          className={grid12}
          css={{
            bg: 'tom.bgBright',
            margin: 'auto',
            maxW: 'var(--max-width)',
            px: 'var(--px)',
          }}
        >
          <GridHalfFull
            css={{
              column: ['1/span 12', undefined, '1/span 5'],
              py: [6, '0'],
            }}
            fw={{ first: true }}
          >
            <Box
              css={{
                position: ['relative', undefined, 'sticky'],
                top: ['unset', undefined, '20'],
              }}
            >
              <HeadingLg
                as="h2"
                classNames="col-span-12 mt-0 mb-0 lg:mb-20 pt-0"
                // css={{
                //   column: '1/span 12',
                //   mt: '0',
                //   mb: ['0', undefined, '20'],
                //   pt: '0',
                // }}
              >
                {diseaseTitle}
              </HeadingLg>
              <TextMd
                css={{
                  display: ['none', undefined, 'block'],
                  hyphens: 'auto',
                }}
                dangerouslySetInnerHTML={{
                  __html: `${diseaseInformation?.replace(/\n/g, '<br />')}`,
                }}
              />
            </Box>
          </GridHalfFull>
          <GridHalfFull css={{ m: '0', p: '0' }}>
            <ListYBorder styleType="circle">
              {diseases &&
                diseases
                  .sort((first: any, second: any) => first.order - second.order)
                  .map((disease: Disease, index: number) => {
                    if(!getLocalizationObj(disease))
                      return null;
                    const { title } = getLocalizationObj(disease);
                    return (
                      <ListItem
                        key={index}
                        css={{
                          '&::before': {
                            content: 'counter(my-counter, circle)',
                            display: ['block', undefined, 'none'],
                            w: ['5'],
                            fontSize: ['1.2em'],
                            flexShrink: '0',
                          },
                          py: ['1'],
                          alignItems: 'baseline',
                          d: ['flex', undefined, 'list-item'],
                          listStyleType: ['none', undefined, 'circle'],
                        }}
                      >
                        {title}
                      </ListItem>
                    );
                  })}
            </ListYBorder>
            <TextMd
              css={{
                mt: ['12'],
                display: ['block', undefined, 'none'],
                hyphens: 'auto',
              }}
              dangerouslySetInnerHTML={{
                __html: `${diseaseInformation?.replace(/\n/g, '<br />')}`,
              }}
            />
          </GridHalfFull>
        </ContainerOuter>
      </Bright>
    );
  }
);
